/* RESPONSIBLE TEAM: team-self-serve */
import Service, { inject as service } from '@ember/service';
import { registerDestructor } from '@ember/destroyable';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type AppService from 'embercom/services/app-service';

export default class TrialPlanSwitchListenerService extends Service {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare customerService: $TSFixMe;
  @service declare appService: AppService;
  @service declare modelDataCacheService: $TSFixMe;

  constructor() {
    super(...arguments);
    let unsubscribe = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'trial-plan-switching:plan-switched',
      () => this.reloadModels(),
    );
    registerDestructor(this, unsubscribe);
  }

  // Called from apps/app route activate() to eagerly instantiate this service
  // so the bridge listener is registered for every route under apps.app —
  // not just the billing route where the modal is opened.
  setup(): void {}

  private async reloadModels(): Promise<void> {
    await this.appService.app.reload();
    await this.appService.app.updateLocalCache(this.modelDataCacheService);
    await this.customerService.resetAll();
    await this.customerService.refreshCustomer();
  }
}

declare module '@ember/service' {
  interface Registry {
    'trial-plan-switch-listener': TrialPlanSwitchListenerService;
  }
}
